/* eslint-disable import/no-import-module-exports */

import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import { apiSlice } from './redux/apiSlice';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(apiSlice.middleware)
    .concat(createLogger({
      collapsed: (getState, action, logEntry) => !logEntry.error,
    })),
  devTools: process.env.NODE_ENV !== 'production',
});

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('.', () => store.replaceReducer(rootReducer));
}

setupListeners(store.dispatch);
